<template>
    <div class="audio" :data-loading="loading">
        <audio ref="player" :src="src" controls controlist="play timeline" @play="play($event)"></audio>
    </div>
</template>

<script>
const axios = require('axios');
export default {
    data() {
        return {
            src: "", // This needs a default path or it doesn't work
            details: "",
            loading: true,
        }
    },
    props: {
        id: Number,
        siloData: Object,
        pauseVideo: Boolean,
        appState: String,
    },
    watch: {
        appState() {
            // Change this to an active or inactive thing I think
            if (this.appState === "home" || this.appState === "topic") {
                this.pause();
            }
        },
        pauseVideo() {
            if (this.pauseVideo === true) {
                console.log('player pause watch true');
                this.pause();
            }
        }
    },
    created() {
        this.getImage();
    },
    methods: {
        async getImage() {
            if (this.id === 0) return;
            
            console.log('getting audio');

            axios.post(this.siloData.urls.getmediafile, { id: this.id }).then((result) => {
                console.log(result);
                this.src = result.data.file;
                this.loading = false;
            }).catch((reason) => {
                console.log(reason);
                this.loading = false;
            });
        },
        pauseAllOtherAudio(event) {
            console.log('pausing all other audio players');
            document.querySelectorAll('audio').forEach(p => {
                if (p !== event.target) {
                    p.pause();
                    p.currentTime = 0;
                }
            });
        },
        play(event = null) {
            console.log(`playing audio: ${this.src}`)
            this.pauseAllOtherAudio(event);
            this.$emit('playingVideo');
            this.$emit('play');
            //this.$refs.player.dataset.status = "playing";
            //console.log(this);
        },
        pause() {
            console.log('WE ARE TRYING TO PAUSE THIS AUDIO PLAYER');
            this.$refs.player.pause();
            this.$refs.player.currentTime = 0;
            //this.$refs.player.dataset.status = "paused";
            //this.$refs.player.unload();
        },
        reset() {

        },
    }
}
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.audio {
    //background-color: var(--color-grey);
    audio {
        opacity: 1;
        transition: all 0.15s;
        height: 60px;
        display: block;
        width: 100%;
    }
    &[data-loading="true"] {
        background-color: transparent;
        img {
            opacity: 0;
        }
    }
}
</style>